import orderBy from 'lodash/orderBy';

/**
 * Sort data based on opts
 *
 * @param {Array} data Data to be sorted
 * @param {Object<SortingOptions>} opts Sorting SortingOptions
 * @returns {Array} Sorted data
 */
export default function sorter(data, opts) {
	return orderBy(
		data,
		[
			//for case insensitive
			item =>
				typeof item[opts.orderBy] === 'string'
					? item[opts.orderBy].toUpperCase()
					: item[opts.orderBy],
		],
		[opts.orderDir]
	);
}



// WEBPACK FOOTER //
// ./src/state/helpers/collated/sorter.js